<script>
import axios from "axios";
import {EventBus} from "@/EventBus";
import BackgroundCard from "@/components/BackgroundCard.vue";


export default {
  name: 'UserBackground',
  props: ['col'],
  components: {BackgroundCard},
  data() {
    return {
      backgrounds: [],
      randomBackground: true
    }
  },
  mounted() {
    this.getUserBackgrounds()
    EventBus.$on('changeBg', this.getUserBackgrounds)
    EventBus.$on('deleteBackground', this.getUserBackgrounds)
  },
  beforeDestroy() {
    EventBus.$off('changeBg', this.getUserBackgrounds)
    EventBus.$off('deleteBackground', this.getUserBackgrounds)
  },
  methods: {
    getUserBackgrounds() {
      axios.get('/api/user/background', {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      }).then(res => {
        this.backgrounds = res.data.data.backgrounds
        this.randomBackground = res.data.data.randomBackground
      })
    },
    changeBackgroundStatus() {
      axios.post('/api/user/background/random', {
        randomBackground: this.randomBackground
      }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.$notify.success({
            title: '操作成功',
            message: '背景设置已更新'
          })
        } else {
          this.$notify.error({
            title: '操作失败',
            message: '遇到了某些错误'
          })
          setTimeout(() => {
            this.randomBackground = !this.randomBackground
          }, 1000)
        }
      })
    }
  }
}
</script>

<template>
  <div class="background-settings">
    <el-card class="background-options" shadow="never">
      <div class="options-row">
        <div><strong>背景来源</strong><p>选择随机背景，或使用已收藏的图片。</p></div>
        <el-switch v-model="randomBackground" active-text="随机背景" inactive-text="收藏的背景" @change="changeBackgroundStatus"></el-switch>
      </div>
    </el-card>
    <div class="background-heading"><strong>收藏的背景</strong><span>{{ backgrounds.length }} 张</span></div>
    <div v-show="backgrounds.length" class="waterfall-container">
      <Waterfall
          :resetSign="true"
          :pageData="backgrounds"
          :column-count="col"
          query-sign="#cardItem">
        <template #default="{ item }">
          <BackgroundCard :background="item" id="cardItem"></BackgroundCard>
        </template>
      </Waterfall>
    </div>
    <el-empty v-if="!backgrounds.length" description="还没有收藏背景"></el-empty>
  </div>
</template>

<style scoped>
.background-options { border: 1px solid rgba(220, 223, 230, .8); border-radius: 12px; background: rgba(255, 255, 255, .48); }
.background-options >>> .el-card__body { padding: 16px; }
.options-row { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; }
.options-row strong, .background-heading strong { font-size: 14px; }
.options-row p { margin: 5px 0 0; color: #909399; font-size: 11px; }
.background-heading { display: flex; justify-content: space-between; align-items: center; margin: 20px 2px 10px; }
.background-heading span { color: #909399; font-size: 11px; }
.waterfall-container { min-height: 0; }
</style>
